import React from "react";
import resumePdf from "../assets/resume.pdf";

function Header() {
  const [navOpen, setNavOpen] = React.useState(false);

  function scrollToSection(id) {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setNavOpen(false);
  }

  function navLink(label, targetId) {
    return React.createElement(
      "a",
      {
        href: "#" + targetId,
        className: "nav-link",
        key: targetId,
        onClick: function (e) {
          e.preventDefault();
          scrollToSection(targetId);
        },
      },
      label,
    );
  }

  return React.createElement(
    "header",
    { className: "site-header" },
    React.createElement(
      "a",
      {
        href: "#cover",
        className: "site-logo",
        onClick: function (e) {
          e.preventDefault();
          scrollToSection("cover");
        },
      },
      "VAN",
      React.createElement("span", null, ".DEV"),
    ),
    React.createElement(
      "button",
      {
        className: "nav-toggle",
        "aria-label": navOpen ? "Close menu" : "Open menu",
        onClick: function () {
          setNavOpen(!navOpen);
        },
      },
      navOpen ? "\u2715" : "\u2630",
    ),
    React.createElement(
      "nav",
      { className: "site-nav" + (navOpen ? " open" : "") },
      navLink("About", "about"),
      navLink("Experience", "experience"),
      navLink("Skills", "skills"),
      navLink("Projects", "works"),
      navLink("Contact", "contact"),
      React.createElement(
        "a",
        {
          href: resumePdf,
          download: "Van_Carlo_Labanan_Resume.pdf",
          className: "nav-link nav-resume",
        },
        "R\u00E9sum\u00E9",
      ),
    ),
  );
}

export default Header;
